export default "__VITE_ASSET__CsvfjTQS__"